
import React from "react";
import { Helmet } from "react-helmet-async";
import { categories } from "@/lib/data";
import CategoryCard from "@/components/category-card";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

const Categories: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-12 bg-white dark:bg-gray-900/10">
      <Helmet>
        <title>Categories - OGMAI</title>
      </Helmet>
      
      <Button variant="ghost" size="sm" asChild className="mb-6 text-gray-600 hover:text-gray-900">
        <Link to="/browse" className="flex items-center">
          <ChevronLeft className="mr-1 h-4 w-4" />
          Back to Browse
        </Link>
      </Button>
      
      <div className="text-center mb-12">
        <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-gray-100">Browse by Category</h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
          Explore our wide range of categories to find the AI agent that fits your needs
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {categories.map((category) => (
          <CategoryCard key={category.id} category={category} />
        ))}
      </div>
    </div>
  );
};

export default Categories;
